import React from 'react';
import { Typography } from '@mui/material';
import { getStatusLabel } from './getStatusLabel';

/**
 * Status display - only shows text for Cancelled status
 */
export const StatusTemplate: React.FC<{ status?: string }> = ({ status }) => {
  const upperStatus = status?.toUpperCase();

  // Only show text for Cancelled status
  if (
    upperStatus === 'CANCEL' ||
    upperStatus === 'CANCELLED' ||
    upperStatus === 'CANCELED'
  ) {
    return (
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.75rem',
          fontWeight: 500,
        }}
      >
        {getStatusLabel(status || '')}
      </Typography>
    );
  }

  return null;
};

export default StatusTemplate;
